import { combineReducers } from 'redux';
import videoCall from './videoCall/reducer';
import signIn from './signIn/reducer';
import leads from './deals/reducer';
import appointments from './appointments/reducer';
import clients from './clients/reducer';
import profile from './profile/reducer';
import bookAppointment from './bookAppointment/reducer';
import agreement from './agreement/reducer';
import auth from './auth/reducer';
import siteplanManagement from './siteplanManagement/reducer';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import confirmation from './confirmations/reducer';
import modals from './modals/reducer';
import form from './forms/reducer';
import filters from './filter/reducer';
import purchasers from './purchasers/reducer';
import salesAgent from './salesAgent/reducer';
import alert from './alerts/reducer';
import userManagement from './userManagement/reducer';
import verification from './verification/reducer';
import reporting from './reporting/reducer';
import location from './location/reducer';

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['signIn', 'profile'],
};

const rootReducer = combineReducers({
	videoCall: videoCall,
	signIn: signIn,
	appointments: appointments,
	clients: clients,
	profile: profile,
	leads: leads,
	confirmation: confirmation,
	bookAppointment: bookAppointment,
	auth: auth,
	siteplanManagement: siteplanManagement,
	modals: modals,
	agreement: agreement,
	forms: form,
	filters: filters,
	purchasers: purchasers,
	salesAgent: salesAgent,
	alert: alert,
	userManagement: userManagement,
	verification: verification,
	reporting: reporting,
	location: location,
});

export default persistReducer(persistConfig, rootReducer);
